/**
 * 在落地页 第三方结果页带token的情况下 自动在天美贷登录
 */
import axios from '../assets/axios'
import { setKey } from '../assets/utils'

export default (query) => {
  const { onceToken, channelNo } = query
  return new Promise(async (resolve, reject) => {
    if (onceToken) {
      const response = await axios.post('/auth/v2/merchant-auth-common', {
        token: onceToken, channelNo: channelNo
      })
      if (response && response.data.success === true) {
        setTimeout(() => {
          setKey('userInfo', Object.assign(response.data.data, { time: Date.now() }))
          // if (!(home === 'T')) {
          //   window.location.href = '/'
          // }
          resolve(true)
        }, 100)
      } else {
        resolve(false)
      }
    } else {
      resolve(true)
    }
  })
}